'use client';

import styles from './expandable-menu-account.module.css';
import * as React from 'react';
import { ExitIcon, PersonIcon } from '@radix-ui/react-icons';
import {
  Avatar,
  Box,
  Button,
  Flex,
  IconButton,
  Inset,
  Popover,
  Separator,
  Spinner,
  Text,
  Tooltip
} from '@radix-ui/themes';
// import clsx from 'clsx';
import classNames from 'classnames';

interface Props {
  open: boolean;
  username: string;
  showAvatar: boolean;
  avatar: string | undefined;
  pending: boolean;
  unsubscribed: boolean;
  subscribed: boolean;
  onNavigateToPersonalAccount: () => void;
  onLogout: () => void;
  onOpenChange: (newState: boolean) => void;
}

export function ExpandableMenuAccount({
  open,
  username,
  showAvatar,
  avatar,
  onNavigateToPersonalAccount,
  onLogout,
  pending,
  unsubscribed,
  subscribed,
  onOpenChange
}: Props) {
  // const badgeClass = clsx(styles.Badge, {
  //   [styles.Pending]: pending,
  //   [styles.Unsubscribed]: unsubscribed
  // });

  return (
    <Popover.Root
      open={open}
      onOpenChange={onOpenChange}
    >
      {subscribed && (
        <Popover.Trigger>
          <IconButton className={styles.AvatarButton}>
            <Avatar
              size='2'
              src={showAvatar ? avatar : undefined}
              fallback={username.charAt(0)}
            />
          </IconButton>
        </Popover.Trigger>
      )}
      {pending && (
        <Tooltip
          content={'Ожидание подтверждения платежа'}
          side='bottom'
        >
          <Popover.Trigger>
            <IconButton className={styles.AvatarButton}>
              <div style={{ position: 'relative' }}>
                <Avatar
                  size='2'
                  src={showAvatar ? avatar : undefined}
                  fallback={username.charAt(0)}
                />
                <div className={styles.Spinner}>
                  <Spinner size='1' />
                </div>
              </div>
            </IconButton>
          </Popover.Trigger>
        </Tooltip>
      )}
      {unsubscribed && (
        <Tooltip
          content='Подписка не оплачена или истекла'
          side='bottom'
        >
          <Popover.Trigger>
            <IconButton className={styles.AvatarButton}>
              <div style={{ position: 'relative' }}>
                <Avatar
                  size='2'
                  src={showAvatar ? avatar : undefined}
                  fallback={username.charAt(0)}
                />
                <Box
                  className={classNames(styles.Badge, styles.Unsubscribed)}
                />
              </div>
            </IconButton>
          </Popover.Trigger>
        </Tooltip>
      )}

      <Popover.Content
        sideOffset={25}
        align='center'
      >
        <Flex
          direction='column'
          align='center'
          gap='2'
        >
          <Inset
            clip='padding-box'
            side='top'
          >
            <div className={styles.MenuHeader}>
              <Avatar
                size='4'
                src={showAvatar ? avatar : undefined}
                fallback={username.charAt(0)}
              />
              <Text weight='medium'>{username}</Text>
            </div>
          </Inset>
          <Box
            width='100%'
            p='4'
          >
            <Flex
              direction='column'
              align='start'
              gap='1'
            >
              <Button
                variant='ghost'
                style={{
                  width: '100%',
                  justifyContent: 'flex-start'
                }}
                onClick={onNavigateToPersonalAccount}
              >
                <PersonIcon />
                Личный кабинет
              </Button>
              <Separator
                my='2'
                size='4'
              />
              <Button
                variant='ghost'
                style={{ width: '100%', justifyContent: 'flex-start' }}
                onClick={onLogout}
              >
                <ExitIcon />
                Выход
              </Button>
            </Flex>
          </Box>
        </Flex>
      </Popover.Content>
    </Popover.Root>
  );
}
